import { decodeJwtExp } from './decode-jwt-exp';

type Refresher = () => Promise<boolean>;

let timer: ReturnType<typeof setTimeout> | null = null;
let refresher: Refresher = async () => false; // overwritten by api-client wiring

/**
 * Test-only: replace the refresher function. In production code, this is
 * wired to `tryRefreshOnce` in `api-client.ts` after both modules load.
 */
export function __setRefresher(fn: Refresher): void {
  refresher = fn;
}

/**
 * Schedule a silent refresh 60s before the given access token expires.
 * If the token is already expired (or expires in <60s), refresh immediately.
 * Cancels any previously scheduled refresh.
 */
export function scheduleSilentRefresh(accessToken: string): void {
  cancelSilentRefresh();
  const expMs = decodeJwtExp(accessToken);
  const delay = expMs - Date.now() - 60_000;
  if (delay <= 0) {
    void refresher();
    return;
  }
  timer = setTimeout(() => {
    timer = null;
    void refresher();
  }, delay);
}

export function cancelSilentRefresh(): void {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
}
